/**
 * 画像・音声アセットのURL解決(docs/05_asset_pipeline.md)。
 *
 * Phase 1 時点でアセットは**まだ生成されていない**。
 * `VITE_ASSETS_BASE` が未設定なら「アセット無し」とみなして URL を返さず、
 * UI 側は画像=非表示 / 音声=スキップで劣化なく動く。
 * 生成後は `VITE_ASSETS_BASE=https://…r2.dev/assets/v1/` を指すだけで有効になる。
 */

const RAW_BASE = import.meta.env.VITE_ASSETS_BASE;

/** アセット配信元。未設定なら null(= アセット無し)。 */
export const ASSETS_BASE: string | null =
  typeof RAW_BASE === 'string' && RAW_BASE.length > 0
    ? RAW_BASE.endsWith('/')
      ? RAW_BASE
      : `${RAW_BASE}/`
    : null;

/** アセットが利用できるか。 */
export function hasAssets(): boolean {
  return ASSETS_BASE !== null;
}

/**
 * コンテンツ側の相対パス(`img/w00014.webp` 等)を配信URLに変換する。
 * アセット未配備、またはパス未指定なら null。
 */
export function assetUrl(relative: string | undefined): string | null {
  if (!relative || ASSETS_BASE === null) return null;
  return `${ASSETS_BASE}${relative.replace(/^\/+/, '')}`;
}
